import { BonusSettlementSupplierStatus } from '@synergy/models';
import { createReducer } from '@reduxjs/toolkit';

import { BonusSettlementDetail } from '../../models/bonus-settlement-detail';
import {
    addCustomer,
    getBonusSettlementDetail,
    removeCustomer,
    resetBonusSettlementDetail,
    resetSubmittedSuccessModal,
    submitBonusSettlementDetail,
} from './bonus-settlements-detail-actions';

export interface BonusSettlementDetailReducerState {
    bonusSettlementDetail: BonusSettlementDetail | null;
    loading: boolean;
    submitted: boolean;
    error: string | null;
}

export const bonusSettlementDetailInitialState: BonusSettlementDetailReducerState = {
    bonusSettlementDetail: null,
    loading: false,
    submitted: false,
    error: null,
};

export const bonusSettlementDetailReducer = createReducer(bonusSettlementDetailInitialState, builder => {
    builder.addCase(getBonusSettlementDetail.pending, state => {
        state.loading = true;
    });
    builder.addCase(getBonusSettlementDetail.fulfilled, (state, action) => {
        state.bonusSettlementDetail = action.payload;
        state.loading = false;
    });
    builder.addCase(submitBonusSettlementDetail.pending, state => {
        state.loading = true;
    });
    builder.addCase(submitBonusSettlementDetail.fulfilled, state => {
        state.submitted = true;
        if (state.bonusSettlementDetail) {
            state.bonusSettlementDetail.status = BonusSettlementSupplierStatus.Sent;
        }
        state.loading = false;
    });

    builder.addCase(submitBonusSettlementDetail.rejected, state => {
        state.submitted = false;
    });
    builder.addCase(resetSubmittedSuccessModal, state => {
        state.submitted = false;
    });
    builder.addCase(resetBonusSettlementDetail, state => {
        state.bonusSettlementDetail = null;
    });
    builder.addCase(addCustomer.fulfilled, (state, action) => {
        if (state.bonusSettlementDetail) {
            state.bonusSettlementDetail.customerBonusSettlements = [
                action.payload,
                ...(state.bonusSettlementDetail.customerBonusSettlements || []),
            ];
        }
        state.loading = false;
    });
    builder.addCase(removeCustomer.fulfilled, (state, action) => {
        if (state.bonusSettlementDetail) {
            state.bonusSettlementDetail.customerBonusSettlements =
                state.bonusSettlementDetail.customerBonusSettlements?.filter(
                    customer => customer.id !== action.payload
                ) || [];
        }
    });
});
